const items = [
  {
    title: "Product-minded engineering",
    description:
      "We build like owners because we are owners. Every decision is weighed against what it costs to run, support, and grow.",
  },
  {
    title: "Small and senior",
    description:
      "No account managers, no hand-offs. You talk directly to the people writing the code.",
  },
  {
    title: "Modern, boring stack",
    description:
      "React, TypeScript, AWS, and pragmatic AI integration. Boring where it should be boring, sharp where it counts.",
  },
  {
    title: "Select engagements",
    description:
      "A few clients at a time, done properly. If we take your project on, it gets our full attention.",
  },
];

const Approach = () => (
  <section id="approach" className="scroll-mt-16 border-t border-line py-24">
    <div className="mx-auto max-w-6xl px-6">
      <p className="font-mono text-xs uppercase tracking-widest text-muted">
        How we work
      </p>
      <h2 className="mt-3 text-3xl font-semibold tracking-tight md:text-4xl">
        Approach
      </h2>
      <div className="mt-12 grid gap-x-12 gap-y-10 sm:grid-cols-2">
        {items.map((item, index) => (
          <div key={item.title}>
            <span className="font-mono text-sm text-accent">
              {String(index + 1).padStart(2, "0")}
            </span>
            <h3 className="mt-2 text-lg font-semibold">{item.title}</h3>
            <p className="mt-2 text-muted">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Approach;
